import { finish, form, error } from '../../../modules/customers/actions/withdraw';

import api from '../../../api';

let messageReceiverInitialized = false;

let $lastId;

function initializeMessageReceiver(dispatch) {
    window.addEventListener('message', (e) => {
        let message = e.data;

        try {
            message = JSON.parse(message);
        } catch (err) {
            return;
        }

        if (message.action !== 'transaction-final') {
            return;
        }

        if (message.type === 'success') {
            api.get('/customers/' + $lastId).then(
                (customer) => dispatch(finish($lastId, { customer })),
                ({ errors }) => dispatch(error($lastId, errors))
            );
        } else {
            dispatch(error($lastId, message.error));
        }
    });
}

export function request(dispatch, { id, amount, paymentMethod }) {
    if (!messageReceiverInitialized) {
        messageReceiverInitialized = true;
        initializeMessageReceiver(dispatch);
    }

    $lastId = id;

    api.post('/customers/' + id + '/withdrawals', { amount, paymentMethod, channel: 'backoffice' }).then(
        (data) => {
            // paymentForm was realexPaymentForm, renamed for backward compatibility
            if (data.paymentForm) {
                dispatch(form(id, data));
            } else if (data.secureTradingPaymentForm) {
                dispatch(form(id, data));
            } else {
                api.get('/customers/' + id).then(
                    (customer) => dispatch(finish(id, { customer, transaction: data })),
                    () => dispatch(finish(id, { transaction: data }))
                );
            }
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
